// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1lmN8","subheader":"ReorderModal_subheader__1fBia","listWrap":"ReorderModal_listWrap__br8n4"};